import './style.css';

const Banner = () => {

  return(
    <section id="banner">
      <iframe width="560" height="315" src="https://www.youtube.com/embed/GW0rj4sNH2w" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </section>
  )
}

export default Banner;